import { ToastProvider } from '@apovisio/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ApiClientError } from '../lib/api';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Pas de nouvelle tentative sur une erreur métier (4xx) : seul le réseau est réessayé.
      retry: (failureCount, error) =>
        failureCount < 2 &&
        (!(error instanceof ApiClientError) || error.network || error.status >= 500),
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  );
}
